import React from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { SiteListPreferencesModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { siteListPreferencesFieldsConfiguration } from './SiteListPreferences.utils';

export const SiteListPreferences: React.FC = () => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue, validateField } =
    useFormikContext<SiteListPreferencesModel>();

  return (
    <div>
      <FormGenerator
        fieldsConfiguration={siteListPreferencesFieldsConfiguration}
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        validateField={validateField}
        formDisabled={false}
        newEditableLook
      />
    </div>
  );
};
